import {Plate} from "../models/plate";
import {DatePipe} from "@angular/common";

const NO_USER_COMMENTED = "No comments were made by any Lab User";

export function showLatestComment(plate:Plate,datePipe:DatePipe): string {
    const latestComment = plate.latestUserComment;
    if(!latestComment){
        return NO_USER_COMMENTED;
    }
    latestComment.comment = latestComment.comment.length < 101 ? latestComment.comment : `${latestComment.comment.substring(0, 101)}...`;
    return `${latestComment.puid} commented:\n\n ${latestComment.comment} \n\n At: ${datePipe.transform(latestComment.timeStamp, "yyyy-MM-dd HH:mm")}`;
}
